var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hyjy"},[_c('div',{staticClass:"hy-title"},[_vm._v("行业经验")]),_c('div',{staticClass:"hyjy-content"},[_c('img',{attrs:{"src":require("@/assets/images/hyjy.png"),"alt":""}})])])
}]

export { render, staticRenderFns }